module.exports = __webpack_public_path__ + "img/KBank-logo.a2858a55.jpg";